import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=4a1cc516&scoped=true&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe.vue?vue&type=style&index=0&id=4a1cc516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cc516",
  null
  
)

export default component.exports